// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}

.myimage {
  width: calc(83 * var(--width-ratio));
}

div {
  text-align: center;
}

ion-grid {
  margin-top: calc(26 * var(--width-ratio));
}
ion-grid ion-row:nth-child(2) {
  margin-top: calc(6 * var(--width-ratio));
}
ion-grid ion-row:nth-child(3) {
  margin-top: calc(4 * var(--width-ratio));
}
ion-grid ion-row:nth-child(4) {
  margin-top: calc(10 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/get-coin-modal/get-coin-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,yCAAA;AACF;AACE;EACE,wCAAA;AACJ;AAEE;EACE,wCAAA;AAAJ;AAGE;EACE,yCAAA;AADJ","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\n.myimage {\n  width: calc(83 * var(--width-ratio));\n}\n\ndiv {\n  text-align: center;\n}\n\nion-grid {\n  margin-top: calc(26 * var(--width-ratio));\n\n  ion-row:nth-child(2) {\n    margin-top: calc(6 * var(--width-ratio));\n  }\n\n  ion-row:nth-child(3) {\n    margin-top: calc(4 * var(--width-ratio));\n  }\n\n  ion-row:nth-child(4) {\n    margin-top: calc(10 * var(--width-ratio));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
